var React = require('react');

function Minus (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M100 41.667H0v16.666h100V41.667Z"}));
}

Minus.defaultProps = {"viewBox":"0 0 100 100"};

module.exports = Minus;

Minus.default = Minus;
